module.exports = __webpack_public_path__ + "img/alipay.25967fc2.svg";